import { forwardRef, useEffect, useState } from "react";
import "./SalePOSPrint.css";

const SalePOSPrint = forwardRef((props, ref) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    setRows(props.rows);
    console.log("pos print", props.rows);
  }, [props.rows]);

  return (
    <div id="receipt-data" style={{ width: "100%", maxWidth: "400px", margin: "0 auto" }} ref={ref}>

      {/* Header Info */}
      <div className="centered" style={{ textAlign: "center" }}>
        <h2 style={{ marginBottom: "5px" }}>{props.businessData ? props.businessData.company_name : ''}</h2>
        <p style={{ fontSize: "11px", lineHeight: "15px", marginTop: "0" }}>
          {props.businessData?.company_email || ''}{props.businessData?.company_phone ? `, ${props.businessData.company_phone}` : ''}
          {props.businessData?.company_address && <><br />{props.businessData.company_address}</>}
        </p>
      </div>

      {/* Meta Info */}
      <p style={{ fontSize: "12px", lineHeight: "16px" }}>
        Date: {props.formData?.date || ''}<br />
        Reference: {props.formData?.reference || ''}<br />
        Name: {props.formData?.customer_details?.customer_name || ''}
      </p>

      {/* Main Order Items Table */}
      <table className="table-data" style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
        <thead>
          <tr style={{ borderBottom: "1px dashed #000" }}>
            <th style={{ textAlign: "left", paddingBottom: "5px" }}>Item Details</th>
            <th style={{ textAlign: "right", paddingBottom: "5px" }}>Total (Rs)</th>
          </tr>
        </thead>
        <tbody>
          {/* Directly mapping props eliminates the asynchronous layout render lag */}
          {rows.map((row, index) => (
            <tr key={row.id || index} style={{ borderBottom: "1px dotted #eee" }}>
              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                <span style={{ fontWeight: "bold" }}>{row.product?.product_name}</span>
                <br />
                <span style={{ fontSize: "11px", color: "#555" }}>
                  {row.quantity} x {row.price}
                </span>
              </td>
              <td style={{ textAlign: "right", verticalAlign: "bottom", padding: "6px 0" }}>
                {row.sub_total}
              </td>
            </tr>
          ))}

          {/* Totals Section */}
          <tr style={{ borderTop: "1px dashed #000" }}>
            <td style={{ padding: "4px 0", textAlign: "left" }}>Tax ({props.formData?.tax_percentage || 0}%) (Rs)</td>
            <td style={{ padding: "4px 0", textAlign: "right" }}>{props.formData?.tax_amount || 0}</td>
          </tr>
          <tr>
            <td style={{ padding: "4px 0", textAlign: "left" }}>Discount ({props.formData?.discount_percentage || 0}%) (Rs)</td>
            <td style={{ padding: "4px 0", textAlign: "right" }}>{props.formData?.discount_amount || 0}</td>
          </tr>
          <tr>
            <td style={{ padding: "4px 0", textAlign: "left" }}>Shipping (Rs)</td>
            <td style={{ padding: "4px 0", textAlign: "right" }}>{props.formData?.shipping_amount || 0}</td>
          </tr>
          <tr style={{ fontWeight: "bold", borderTop: "1px solid #000" }}>
            <td style={{ padding: "6px 0", textAlign: "left" }}>Grand Total (Rs)</td>
            <td style={{ padding: "6px 0", textAlign: "right" }}>{props.formData?.total_amount || 0}</td>
          </tr>
        </tbody>
      </table>

      {/* Payment Block */}
      <table style={{ width: "100%", marginTop: "15px", borderCollapse: "collapse" }}>
        <tbody>
          <tr style={{ backgroundColor: "#ddd" }}>
            <td style={{ padding: "6px", textAlign: "center", fontSize: "11px" }}>
              Paid By: <strong>{props.formData?.payment_method || 'N/A'}</strong>
            </td>
            <td style={{ padding: "6px", textAlign: "center", fontSize: "11px" }}>
              Amount: <strong>Rs {props.formData?.paid_amount || 0}</strong>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Footer Footer Footer */}
      <div style={{ textAlign: "center", marginTop: "15px", fontSize: "10px", color: "#666" }}>
        Powered by REYONS SOFT
      </div>
    </div>
  );
});

export default SalePOSPrint;
